import * as apiGetDetails from 'api/shoppingCart/GetShoppingCartGetDetailsIdV1';
import * as apiPutAppearances from 'api/shoppingCart/PutShoppingCartUpdateAppearancesIdV1';
import { Appearance } from 'types/ShoppingCart/Appearance';
import EntityType from 'types/ShoppingCart/EntityType';

export * as AppearanceList from './AppearanceList';

export type Type = Appearance.Type[];

export function create(): Type {
	return [];
}

export function setQuantity(appearances: Type, id: string, quantity: number): Type {
	return appearances.map((e) => {
		if (e.id !== id) return e;
		return { ...e, quantity: quantity };
	});
}

export function mapFromApi(list: Type, input: apiGetDetails.Appearances[]): Type {
	return input.map((e) => {
		const appearance = list.find((x) => x.id === e.entityId);
		if (!appearance) return Appearance.mapFromApi(e);
		return {
			...appearance,
			quantity: e.quantity,
		};
	});
}

export function mapToApi(input: Type): apiPutAppearances.RequestBody {
	return {
		appearances: input.map((e) => ({
			entityId: e.id,
			entityType: e.type,
			quantity: e.quantity,
		})),
	};
}

export function getAmountOfEntity(list: Type, entityType: EntityType): number {
	let output: number = 0;
	for (const i of list) {
		if (i.type === entityType) output = output + i.quantity;
	}
	return output;
}

export function removeAppearance(list: Type, id: string) {
	return list.filter((e) => e.id !== id);
}
